import type { stateNamesToTrack } from '~/subscription-management/utils/tracking';
import {
  prettifiedStepNameByStateNameMap,
  trackCheckout,
} from '~/subscription-management/utils/tracking';

interface Params {
  accountId: number;
  customerId: number | undefined;
  state: string[];
  stateHistory: string[];
}

const getStepFromStates = (states: string[] = []) =>
  states.filter(
    (state) =>
      state.includes('editOrder.steps.') ||
      state.includes('processOrder.') ||
      state.includes('confirmOrder.'),
  )[0];

export const trackStepIn = ({ accountId, customerId, state, stateHistory }: Params): void => {
  const previousState = getStepFromStates(stateHistory) as stateNamesToTrack;
  const currentState = getStepFromStates(state) as stateNamesToTrack;

  trackCheckout('Wizard Step In', {
    wizardName: 'Checkout',
    accountId,
    customerId,
    stepName: prettifiedStepNameByStateNameMap[currentState],
    previousStep: prettifiedStepNameByStateNameMap[previousState],
  });
};

export const trackStepOut = ({ accountId, customerId, state, stateHistory }: Params): void => {
  const currentState = getStepFromStates(stateHistory) as stateNamesToTrack;
  const nextState = getStepFromStates(state) as stateNamesToTrack;

  trackCheckout('Wizard Step Out', {
    wizardName: 'Checkout',
    accountId,
    customerId,
    stepName: prettifiedStepNameByStateNameMap[currentState],
    nextStep: prettifiedStepNameByStateNameMap[nextState],
  });
};
